export default function Button({ text, onClick }: any) {
  return (
    <div
      onClick={() => onClick()}
      className="border border-black rounded-md py-1 px-3 text-center font-boska text-lg md:text-xl font-light mt-5 hover:cursor-pointer duration-300 hover:scale-105 ease-linear"
    >
      <p>{text}</p>
    </div>
  );
}

export function Button2({ text }: any) {
  return (
    <div className="border border-black rounded-md py-1 px-3 text-center font-boska text-lg md:text-xl font-light mt-5 hover:cursor-pointer duration-300 hover:scale-105 ease-linear">
      <p>{text}</p>
    </div>
  );
}


